<script type="text/jsx">
    export default {
        name: 'Flexbox',
        render(h) {
          return h('ul', {
            class: ['box']
          }, this.$slots.default);
        }
    }
</script>

<style scoped lang="less">
    .box{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content:space-between;
    }
</style>
